import {Router} from "@angular/router";
import {LngKeys} from "@app/common/enums/lng-keys";
import {RoutePath, RoutePaths} from "@app/common/interfaces/route-paths";
import {AppStateService} from "@app/common/services/app-state.service";

export const getUrlLngRoute = (lngKey: LngKeys, partValue: string, routePaths: RoutePaths, newLngKey: LngKeys) => {
  // Get the object of the specified language
  const lngObject = routePaths[lngKey as keyof RoutePaths];

  // Find the key in the language object where the value contains the partValue
  const keyName = Object.keys(lngObject)
    .find((key) => lngObject[key as keyof RoutePath].includes(partValue));

  // If the key is found, get the corresponding value from the English object
  if (keyName) {
    return routePaths[newLngKey as keyof RoutePaths][keyName as keyof RoutePath];
  }

  return '';
}

export const currentLngKey = (router: Router) => {
  const paths = router.url.split('/').filter((path) => path.length);

  let lng: LngKeys = paths.at(0) as LngKeys || LngKeys.EN;
  if (!Object.values(LngKeys).includes(lng as LngKeys)) {
    lng = LngKeys.EN;
  }

  return lng;
}

export const redirectToTranslatedPath = (router: Router, newLng: LngKeys) => {
  const currentUrl = router.url;

  // Remove existing language prefix if present
  const pathWithoutLang = currentUrl.replace(/^\/(ru|hy)(?=\/|$)/, '');

  let newUrl = '';

  if (newLng === LngKeys.EN) {
    newUrl = pathWithoutLang || '/';
  } else {
    newUrl = `/${newLng}${pathWithoutLang}`;
  }

  newUrl = newUrl.endsWith('/')
    ? newUrl.slice(0, -1)
    : newUrl;

  router.navigateByUrl(newUrl);
}

